import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Comprás',
  description: 'Completá tu compra segura en pesos argentinos.'
}, {
  number: '02',
  title: 'Recibís el acceso',
  description: 'Después de confirmar el pago, recibís las instrucciones para acceder al material.'
}, {
  number: '03',
  title: 'Elegís tu primer paso',
  description: 'Abrí “Empezá acá” y elegí la práctica que quieras explorar.'
}];
export function HowItWorks() {
  return <section className="w-full bg-lavender px-5 py-12 sm:py-16" data-id="element-121" data-mp="qj3eusgeqd7o">
      <div className="mx-auto max-w-5xl" data-id="element-122" data-mp="qil7p0s7iekz">
        <h2 className="mx-auto max-w-2xl text-center font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-123" data-mp="cshu0y7e7t75">
          ¿Cómo accedés a Aura Viva 2026?
        </h2>

        <ol className="mt-9 flex flex-col items-stretch gap-4 md:flex-row md:gap-4" data-id="element-124" data-mp="14j5ue818sujr">
          {steps.map((step, i) => <motion.li key={step.number} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-1 flex-col rounded-2xl border border-aura/15 bg-card p-6" data-id="element-125" data-mp="199m9dwkpoo88" data-mpi={i}>
              <span className="font-serif-display text-3xl font-bold leading-none text-gold" data-id="element-126" data-mp="2wjps8tz7u8on">
                {step.number}
              </span>
              <h3 className="mt-3 text-base font-bold leading-snug text-plum sm:text-lg" data-id="element-127" data-mp="3ae8kiclg3vt8">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-plum/75" data-id="element-128" data-mp="3kav4kz5y6iu7">{step.description}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}